import { ADS, adsEnabled } from './config';

declare global {
  interface Window {
    adsbygoogle?: Array<Record<string, unknown>> & { requestNonPersonalizedAds?: number; pauseAdRequests?: number };
  }
}

let loading = false;

/** Adds the AdSense script once. Google's consent message (EEA/UK/CH) is served by this same tag. */
export function loadAdSense(): void {
  if (loading || !adsEnabled() || typeof document === 'undefined') return;
  loading = true;
  const q = (window.adsbygoogle = window.adsbygoogle || ([] as never));
  if (ADS.nonPersonalized) q.requestNonPersonalizedAds = 1;
  const s = document.createElement('script');
  s.async = true;
  s.crossOrigin = 'anonymous';
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(ADS.client)}`;
  document.head.appendChild(s);
}
